// Fetch categories from the API
import instance from "../../utils/axios";

export const endProductTime = async (productID, activityId) => {
  try {
    if (!activityId) {
      throw new Error("Activity Id is required.");
    }
    if (!productID) {
      throw new Error("Products ID is required.");
    }
    return await instance.get(
      `/end-time-in-product/${encodeURIComponent(
        productID
      )}/${encodeURIComponent(activityId)}`
    );
  } catch (error) {
    console.error("Error fetching products:", error.message);
    throw error; // Rethrow for further handling
  }
};
